import { render, staticRenderFns } from "./DepotDetail.vue?vue&type=template&id=8348a642&"
import script from "./DepotDetail.vue?vue&type=script&lang=js&"
export * from "./DepotDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports